import { FC } from "react";
import { Box, alpha } from "@mui/material";
import { Theme } from "@mui/material/styles";

// Badge shown next to the policy name, colored by document type inferred from source_url.
export const PolicyTypeBadge: FC<{ sourceUrl?: string }> = ({ sourceUrl }) => {
  const url = (sourceUrl || "").toLowerCase();
  
  const { label, color, bgcolor } = url.endsWith(".pdf")
    ? {
        label: "PDF",
        color: "error.main",
        bgcolor: (theme: Theme) => alpha(theme.palette.error.main, 0.1),
      }
    : url.endsWith(".doc") || url.endsWith(".docx")
      ? {
          label: "DOC",
          color: "info.main",
          bgcolor: (theme: Theme) => alpha(theme.palette.info.main, 0.1),
        }
      : { label: "URL", color: "text.secondary", bgcolor: "grey.100" };

  return (
    <Box
      sx={{
        flexShrink: 0,
        px: 0.75,
        py: 0.25,
        borderRadius: "4px",
        fontSize: "0.6875rem",
        fontWeight: 700,
        color,
        bgcolor,
        lineHeight: 1.4,
      }}
    >
      {label}
    </Box>
  );
};
